import CalendarToday from "@/components/icons/CalendarToday";
import CircleCheck from "@/components/icons/CircleCheck";
import Clock from "@/components/icons/Clock";
import { Certificate, TrendingUp } from "@/components/icons";
import TrendingPoints from "@/components/icons/TrendingPoints";
import CustomerService from "@/components/icons/CustomerService";
import Timelapse from "@/components/icons/Timelapse";
import People from "@/components/icons/People";
import Money from "@/components/icons/Money";
import MoneyOutlined from "@/components/icons/MoneyOutline";
import EventBusy from "@/components/icons/EventBusy";
import Person from "@/components/icons/Person";
import Speedometer from "@/components/icons/Speedometer";
import EarnSkills from "@/components/icons/EarnSkills";
import CertificateRibbon from "@/components/icons/CertificateRibbon";
import Sale from "@/components/icons/Sale";
import Icon from "@/components/icons";
import { IconTypes } from "@/components/icons/types";

const getIconFromName = (icon: string, iconSize?: string): React.ReactNode => {
  const size = iconSize ?? "48";

  switch (icon) {
    case "calendar-today":
      return <CalendarToday svgProps={{ width: size, height: size }} />;
    case "certificate":
      return <Certificate svgProps={{ width: size, height: size }} />;
    case "certificate-ribbon":
      return <CertificateRibbon svgProps={{ width: size, height: size }} />;
    case "check-circle":
      return <CircleCheck svgProps={{ width: size, height: size }} />;
    case "clock":
      return <Clock svgProps={{ width: size, height: size }} />;
    case "earn-skills":
      return <EarnSkills svgProps={{ width: size, height: size }} />;
    case "event-busy":
      return <EventBusy svgProps={{ width: size, height: size }} />;
    case "trending-up":
      return <TrendingUp svgProps={{ width: size, height: size }} />;
    case "trending-points":
      return <TrendingPoints svgProps={{ width: size, height: size }} />;
    case "customer-service":
      return <CustomerService svgProps={{ width: size, height: size }} />;
    case "people":
      return <People svgProps={{ width: size, height: size }} />;
    case "timelapse":
      return <Timelapse svgProps={{ width: size, height: size }} />;
    case "money":
      return <Money svgProps={{ width: size, height: size }} />;
    case "money-outline":
      return <MoneyOutlined svgProps={{ width: size, height: size }} />;
    case "person":
      return <Person svgProps={{ width: size, height: size }} />;
    case "sale":
      return <Sale svgProps={{ width: size, height: size }} />;
    case "speedometer":
      return <Speedometer svgProps={{ width: size, height: size }} />;
    default:
      return (
        <Icon
          type={icon as IconTypes}
          svgProps={{ width: size, height: size }}
        />
      );
  }
};

export default getIconFromName;
